import React from "react";
import { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NavBar from "../navabar/navbar";
import "./home.css";
import FileOperations from "../file/file";
import EditOperations from "../edit/edit";
import InsertImage from "../image/image";
import Settings from "../settings/settings";
import Output from "../output/output";
import MainDisplay from "../maindisplay/maindisplay";
import Map from "../map/map";
import MapWithDraw from "../map/mapdraw";



export default function HomePage() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileContent, setFileContent] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [settings, setSettings] = useState(null);
  const [activeOperation, setActiveOperation] = useState(null);

  return (
    <div className="container mt-4">
      <NavBar setActiveOperation={setActiveOperation} />

      <Routes>
        <Route
          path="/"
          element={
            <MainDisplay
              selectedFile={selectedFile}
              editedContent={fileContent}
              selectedImage={selectedImage}
              activeOperation={activeOperation}
            />
          }
        />
        <Route path="/map" element={<Map />} />
        <Route path="/mapdraw" element={<MapWithDraw/>}/>
      </Routes>

      <div className="operation-container mt-3">
        {activeOperation === "file" && (
          <FileOperations setSelectedFile={setSelectedFile} setFileContent={setFileContent} />
        )}
        {activeOperation === "edit" && (
          <EditOperations fileContent={fileContent} setFileContent={setFileContent} />
        )}
        {activeOperation === "image" && <InsertImage setSelectedImage={setSelectedImage} />}
        {activeOperation === "settings" && <Settings setSettings={setSettings} />}
        {activeOperation === "output" && <Output fileContent={fileContent} />}
      </div>

      {settings && <p className="mt-2">Applied Setting: {settings}</p>}
    </div>
  );
}